import { gql } from '../../../apollo/__generated__';

export const UPDATE_USER_TINDER_JOINED = gql(`
  mutation UpdateUserTinderJoined($updateUserTinderJoinedInput: UpdateUserTinderJoinedInput!) {
    updateUserTinderJoined(updateUserTinderJoinedInput: $updateUserTinderJoinedInput) {
      id
      hasJoinedTinder
    }
  }
`);
